(function () {
  var FAVKEY = 'wsm_fav_v1';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function readFav() {
    try { return JSON.parse(localStorage.getItem(FAVKEY) || '[]'); } catch (e) { return []; }
  }
  function writeFav(a) {
    try { localStorage.setItem(FAVKEY, JSON.stringify(a.slice(0, 60))); } catch (e) {}
  }

  var ICON = {
    x: '<svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    heart: '<svg viewBox="0 0 24 24"><path d="M12 20s-7.2-4.5-9.2-9A5 5 0 0112 5.6 5 5 0 0121.2 11c-2 4.5-9.2 9-9.2 9z"/></svg>',
    bag: '<svg viewBox="0 0 24 24"><path d="M4 8h16l-1.4 11.2a2 2 0 01-2 1.8H7.4a2 2 0 01-2-1.8L4 8z"/><path d="M8.5 8V6.5a3.5 3.5 0 017 0V8"/></svg>'
  };

  /* ---------- panels ---------- */
  var mask, panels = {};
  function ensure() {
    if (mask) return;
    mask = document.createElement('div');
    mask.className = 'ux-mask';
    mask.addEventListener('click', closeAll);
    document.body.appendChild(mask);
  }
  function makePanel(key, title) {
    ensure();
    var p = document.createElement('aside');
    p.className = 'ux-pan';
    p.setAttribute('role', 'dialog');
    p.innerHTML = '<div class="ux-pan__h"><b>' + title + '</b><em data-ux-sub></em>' +
      '<button class="ux-x" type="button" aria-label="Close">' + ICON.x + '</button></div>' +
      '<div class="ux-pan__b" data-ux-body></div>' +
      '<div class="ux-pan__f" data-ux-foot></div>';
    $('.ux-x', p).addEventListener('click', closeAll);
    document.body.appendChild(p);
    panels[key] = p;
    return p;
  }
  function closeAll() {
    Object.keys(panels).forEach(function (k) { panels[k].classList.remove('on'); });
    if (mask) mask.classList.remove('on');
    document.body.style.overflow = '';
  }
  function open(key) {
    var p = panels[key];
    if (!p) return;
    closeAll();
    render(key);
    p.classList.add('on');
    mask.classList.add('on');
    document.body.style.overflow = 'hidden';
  }

  /* ---------- favourites ---------- */
  function favCount() { return readFav().length; }
  function syncFavButtons() {
    var list = readFav().map(function (x) { return x.h; });
    $$('[data-wp-fav]').forEach(function (b) {
      b.classList.toggle('on', list.indexOf(b.getAttribute('data-h')) >= 0);
    });
    var d = $('[data-ux-fav-count]');
    if (d) { d.textContent = list.length; d.classList.toggle('on', list.length > 0); }
  }
  function toggleFav(b) {
    var h = b.getAttribute('data-h');
    var a = readFav();
    var i = -1;
    a.forEach(function (x, n) { if (x.h === h) i = n; });
    if (i >= 0) a.splice(i, 1);
    else a.unshift({ h: h, t: b.getAttribute('data-t'), u: b.getAttribute('data-u'), i: b.getAttribute('data-i'), p: b.getAttribute('data-p') });
    writeFav(a);
    syncFavButtons();
    if (panels.fav && panels.fav.classList.contains('on')) render('fav');
  }

  /* ---------- set (bundle) ---------- */
  function picks() { return $$('[data-wp-pick]').filter(function (i) { return i.checked; }); }
  function bar() {
    var p = picks()[0];
    if (p) { var b = p.closest('.wp-goalres, .wp'); var bb = b ? $('.wp-bundlebar', b) : null; if (bb) return bb; }
    return $('.wp-bundlebar');
  }
  function syncSet() {
    var n = picks().length;
    var d = $('[data-ux-set-count]');
    if (d) { d.textContent = n; d.classList.toggle('on', n > 0); }
    var chip = $('.ux-chip');
    if (chip) { chip.classList.toggle('on', n > 0); $('u', chip).textContent = n; }
    if (panels.set && panels.set.classList.contains('on')) render('set');
  }

  /* ---------- rendering ---------- */
  function row(img, title, url, price, onRemove) {
    var d = document.createElement('div');
    d.className = 'ux-row';
    d.innerHTML = (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<img alt="">') +
      '<div class="ux-row__b"><a class="ux-row__t" href="' + (url || '#') + '">' + title + '</a>' +
      (price ? '<div class="ux-row__p">' + price + '</div>' : '') + '</div>' +
      '<button class="ux-rm" type="button" aria-label="Remove">' + ICON.x + '</button>';
    $('.ux-rm', d).addEventListener('click', onRemove);
    return d;
  }
  function empty(icon, text) {
    return '<div class="ux-empty">' + icon + '<div>' + text + '</div></div>';
  }

  function render(key) {
    var p = panels[key];
    var body = $('[data-ux-body]', p);
    var foot = $('[data-ux-foot]', p);
    var sub = $('[data-ux-sub]', p);
    body.innerHTML = '';
    if (key === 'fav') {
      var a = readFav();
      sub.textContent = a.length ? a.length + ' items' : '';
      if (!a.length) {
        body.innerHTML = empty(ICON.heart, 'No saved items yet<br>Tap the heart on a product to save it for later');
        foot.innerHTML = '<a class="ux-cta" href="/collections/all">Browse all products</a>';
        return;
      }
      a.forEach(function (x) {
        body.appendChild(row(x.i, x.t, x.u, x.p, function () {
          var b = readFav().filter(function (y) { return y.h !== x.h; });
          writeFav(b); syncFavButtons(); render('fav');
        }));
      });
      foot.innerHTML = '<a class="ux-cta" href="/collections/all">Browse more products</a>';
      return;
    }
    /* set */
    var ps = picks();
    sub.textContent = ps.length ? ps.length + ' items' : '';
    if (!ps.length) {
      body.innerHTML = empty(ICON.bag, 'No products in your set yet<br>Tick “Add to set” under any product');
      foot.innerHTML = '';
      return;
    }
    ps.forEach(function (inp) {
      var card = inp.closest('.wp-card');
      var im = card ? $('.wp-card__m img', card) : null;
      var link = card ? $('.wp-card__n', card) : null;
      var pr = card ? $('[data-card-price]', card) : null;
      body.appendChild(row(im ? im.src : '', inp.getAttribute('data-title') || (link ? link.textContent.trim() : ''),
        link ? link.getAttribute('href') : '#', pr ? pr.textContent.trim() : '', function () {
          inp.checked = false;
          inp.dispatchEvent(new Event('change', { bubbles: true }));
          setTimeout(syncSet, 30);
        }));
    });
    var bb = bar();
    var tot = bb ? $('[data-bundle-total]', bb) : null;
    var hint = bb ? $('[data-bundle-hint]', bb) : null;
    var add = bb ? $('[data-bundle-add]', bb) : null;
    foot.innerHTML = '<div class="ux-sum"><span>Set total</span><b>' + (tot ? tot.innerHTML : '—') + '</b></div>' +
      '<span class="ux-hint">' + (hint ? hint.textContent : '') + '</span>' +
      '<button class="ux-cta" type="button"' + (add && add.disabled ? ' disabled' : '') + '>' +
      (add ? add.textContent.trim() : 'Add the whole set to cart') + '</button>';
    var cta = $('.ux-cta', foot);
    if (cta) cta.addEventListener('click', function () {
      if (add && !add.disabled) { add.click(); setTimeout(closeAll, 400); }
    });
  }

  /* ---------- boot ---------- */
  function boot() {
    makePanel('fav', 'Saved items');
    makePanel('set', 'My set');
    var chip = document.createElement('button');
    chip.type = 'button';
    chip.className = 'ux-chip';
    chip.innerHTML = ICON.bag + '<span>My set</span><u>0</u>';
    chip.addEventListener('click', function () { open('set'); });
    document.body.appendChild(chip);

    document.addEventListener('click', function (e) {
      var o = e.target.closest ? e.target.closest('[data-ux-open]') : null;
      if (o) { e.preventDefault(); open(o.getAttribute('data-ux-open')); return; }
      var f = e.target.closest ? e.target.closest('[data-wp-fav]') : null;
      if (f) { e.preventDefault(); e.stopPropagation(); toggleFav(f); return; }
      var cp = e.target.closest ? e.target.closest('[data-ux-copy]') : null;
      if (cp) {
        e.preventDefault();
        var done = function () { cp.classList.add('done'); setTimeout(function () { cp.classList.remove('done'); }, 1600); };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(location.href).then(done, function () {});
        else { var ta = document.createElement('textarea'); ta.value = location.href; document.body.appendChild(ta); ta.select(); try { document.execCommand('copy'); done(); } catch (err) {} document.body.removeChild(ta); }
        return;
      }
      var m = e.target.closest ? e.target.closest('[data-ux-more]') : null;
      if (m) {
        var d = m.previousElementSibling;
        var open2 = d.classList.toggle('clamp');
        m.textContent = open2 ? 'Read more' : 'Show less';
      }
    }, true);
    document.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches('[data-wp-pick]')) setTimeout(syncSet, 20);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

    syncFavButtons();
    syncSet();
    setTimeout(function () { syncFavButtons(); syncSet(); }, 500);
    document.addEventListener('shopify:section:load', function () { syncFavButtons(); syncSet(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

  (function(){function hm(){document.querySelectorAll('[data-ux-more]').forEach(function(b){var d=b.previousElementSibling;if(!d)return;var was=d.classList.contains('clamp');if(!was)return;if(d.scrollHeight<=d.clientHeight+2){b.style.display='none';d.classList.remove('clamp')}else{b.style.display=''}})}if(document.readyState!=='loading'){setTimeout(hm,60)}else{document.addEventListener('DOMContentLoaded',function(){setTimeout(hm,60)})}addEventListener('load',hm);addEventListener('resize',hm)})();

  (function(){var h=document.querySelector('[data-wp-header]');if(!h)return;var last=window.scrollY||0,tick=false,idle=null,hover=false,IDLE=4000;
  function busy(){return !!h.querySelector('[aria-expanded="true"]')||hover||h.contains(document.activeElement)||document.body.classList.contains('wp-lock')}
  function stopIdle(){if(idle){clearTimeout(idle);idle=null}}
  function armIdle(){stopIdle();idle=setTimeout(function(){idle=null;if((window.scrollY||0)>90&&!busy()){h.classList.add('wp-hd--hide')}},IDLE)}
  function show(){h.classList.remove('wp-hd--hide');armIdle()}
  function hide(){stopIdle();h.classList.add('wp-hd--hide')}
  function upd(){tick=false;var y=window.scrollY||0;
    if(y<90){stopIdle();h.classList.remove('wp-hd--hide');h.classList.remove('wp-hd--stuck');last=y;return}
    h.classList.add('wp-hd--stuck');
    if(busy()){stopIdle();h.classList.remove('wp-hd--hide');last=y;return}
    var d=y-last;
    if(d>8){hide();last=y}
    else if(d<-8){show();last=y}
  }
  window.addEventListener('scroll',function(){if(tick)return;tick=true;if(window.requestAnimationFrame){requestAnimationFrame(upd);setTimeout(function(){if(tick)upd()},120)}else{setTimeout(upd,16)}},{passive:true});
  h.addEventListener('mouseenter',function(){hover=true;stopIdle();h.classList.remove('wp-hd--hide')});
  h.addEventListener('mouseleave',function(){hover=false;if((window.scrollY||0)>90&&!h.classList.contains('wp-hd--hide'))armIdle()});
  document.addEventListener('focusin',function(e){if(h.contains(e.target)){stopIdle();h.classList.remove('wp-hd--hide')}});
  document.addEventListener('focusout',function(e){if(h.contains(e.target)&&(window.scrollY||0)>90)armIdle()});
  upd();})();

  (function(){var h=document.querySelector('[data-wp-header]');if(!h)return;var host=h.parentNode;var sp=document.createElement('div');sp.className='wp-hdsp';if(host)host.insertBefore(sp,h.nextSibling);var base=0;function sz(){if(h.classList.contains('wp-hd--stuck'))return;var v=h.offsetHeight;if(v>40){base=v;sp.style.height=v+'px'}}if(document.readyState!=='loading')setTimeout(sz,50);else document.addEventListener('DOMContentLoaded',function(){setTimeout(sz,50)});window.addEventListener('load',sz);window.addEventListener('resize',sz);})();

/* LCHAT2 */
(function(){
  var a=document.querySelector('.wp-lchat');if(!a)return;
  var tw=a.querySelector('.wp-lchat__t');
  var tt=tw?(tw.querySelector('b')||{}).textContent||'':'';
  var ts=tw?(tw.querySelector('i')||{}).textContent||'':'';
  var touch=window.matchMedia('(hover:none)').matches;
  var timer=null;
  if(touch){
    a.addEventListener('click',function(e){
      if(!a.classList.contains('is-open')){e.preventDefault();a.classList.add('is-open');
        clearTimeout(timer);timer=setTimeout(function(){a.classList.remove('is-open')},4200)}
    })
  }
  var seen=false;try{seen=localStorage.getItem('wpLineSeen')==='1'}catch(e){}
  if(seen||!tt)return;
  var b=document.createElement('div');b.className='wp-lbub';
  b.innerHTML='<b></b><i></i><button class="wp-lbub__x" type="button" aria-label="Close">&times;</button>';
  b.querySelector('b').textContent=tt;b.querySelector('i').textContent=ts;
  document.body.appendChild(b);
  var hide=function(){b.classList.remove('on');setTimeout(function(){b.remove()},400)};
  b.querySelector('.wp-lbub__x').addEventListener('click',function(e){e.stopPropagation();hide()});
  b.addEventListener('click',function(){window.open(a.href,'_blank','noopener')});
  setTimeout(function(){b.classList.add('on')},1400);
  setTimeout(hide,11000);
  try{localStorage.setItem('wpLineSeen','1')}catch(e){}
})();

/* MARQ2 */
(function(){
  var t=document.querySelector('.wp-ann__t');if(!t||t.closest('.wp-annm'))return;
  var p=t.parentElement;if(!p)return;
  var base=t.innerHTML,g=0;
  while(t.scrollWidth<p.clientWidth+200&&g++<12){t.insertAdjacentHTML('beforeend',base)}
  var w=document.createElement('div');w.className='wp-annm';
  p.insertBefore(w,t);w.appendChild(t);
  var c=t.cloneNode(true);c.setAttribute('aria-hidden','true');w.appendChild(c);
  var d=Math.max(18,Math.round(t.scrollWidth/58));
  w.style.setProperty('--annd',d+'s');
})();

/* IBLABEL */
(function(){
  var m=[['wp-ib--set','Set'],['wp-ib--fav','Saved'],['wp-ib--pts','Points'],['wp-ib--cart','Cart']];
  var b=document.querySelectorAll('.wp-hd .wp-ib');
  for(var i=0;i<b.length;i++){var e=b[i],l='Account';
    for(var j=0;j<m.length;j++){if(e.classList.contains(m[j][0])){l=m[j][1];break}}
    e.setAttribute('data-lb',l)}
})();

/* RWARROW */
(function(){var g=document.querySelector(".rw-g--rail");if(!g||g.parentElement.classList.contains("rw-wrap"))return;var w=document.createElement("div");w.className="rw-wrap";g.parentElement.insertBefore(w,g);w.appendChild(g);var mk=function(d,p){var b=document.createElement("button");b.type="button";b.className="rwa rwa--"+d;b.setAttribute("aria-label",d==="p"?"Previous":"Next");b.innerHTML='<svg viewBox="0 0 24 24" width="19" height="19" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="'+p+'"/></svg>';w.appendChild(b);return b};var pv=mk("p","M15 5l-7 7 7 7"),nx=mk("n","M9 5l7 7-7 7");var st=function(){pv.disabled=g.scrollLeft<8;nx.disabled=g.scrollLeft+g.clientWidth>=g.scrollWidth-8};var go=function(s){var c=g.querySelector(".rw-c");var d=c?c.getBoundingClientRect().width+16:320;g.scrollBy({left:s*d*2,behavior:"smooth"})};pv.addEventListener("click",function(){go(-1)});nx.addEventListener("click",function(){go(1)});g.addEventListener("scroll",st,{passive:true});window.addEventListener("resize",st);st()})();

/* CLIPS */
(function(){
  var wraps=document.querySelectorAll('.cl-wrap');
  for(var w=0;w<wraps.length;w++){(function(wr){
    var g=wr.querySelector('.cl-g--rail');if(!g)return;
    var mk=function(d,p){var b=document.createElement('button');b.type='button';b.className='cla cla--'+d;
      b.setAttribute('aria-label',d==='p'?'Previous':'Next');
      b.innerHTML='<svg viewBox="0 0 24 24" width="19" height="19" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="'+p+'"/></svg>';
      wr.appendChild(b);return b};
    var pv=mk('p','M15 5l-7 7 7 7'),nx=mk('n','M9 5l7 7-7 7');
    var st=function(){pv.disabled=g.scrollLeft<8;nx.disabled=g.scrollLeft+g.clientWidth>=g.scrollWidth-8};
    var go=function(s){var c=g.querySelector('.cl-c');var d=c?c.getBoundingClientRect().width+16:300;g.scrollBy({left:s*d,behavior:'smooth'})};
    pv.addEventListener('click',function(){go(-1)});nx.addEventListener('click',function(){go(1)});
    g.addEventListener('scroll',st,{passive:true});window.addEventListener('resize',st);st();
  })(wraps[w])}

  var lb=document.querySelector('[data-cl-lb]');if(!lb)return;
  var stage=lb.querySelector('[data-cl-stage]');
  var prod=lb.querySelector('[data-cl-prod]');
  var emb=function(u){
    if(/youtu\.be\//.test(u))return 'https://www.youtube.com/embed/'+u.split('youtu.be/')[1].split(/[?&]/)[0]+'?autoplay=1';
    if(/youtube\.com\/watch/.test(u)){var m=u.match(/[?&]v=([^&]+)/);if(m)return 'https://www.youtube.com/embed/'+m[1]+'?autoplay=1'}
    if(/youtube\.com\/shorts\//.test(u))return 'https://www.youtube.com/embed/'+u.split('/shorts/')[1].split(/[?&]/)[0]+'?autoplay=1';
    return u};
  var close=function(){stage.innerHTML='';lb.hidden=true;document.body.style.overflow=''};
  var open=function(b){
    var src=b.getAttribute('data-src')||'';var e=b.getAttribute('data-embed')||'';
    stage.innerHTML = src ? '<video src="'+src+'" controls autoplay playsinline></video>'
                          : (e ? '<iframe src="'+emb(e)+'" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>' : '');
    var u=b.getAttribute('data-purl');
    if(u){prod.href=u;prod.hidden=false;
      lb.querySelector('[data-cl-pimg]').src=b.getAttribute('data-pimg')||'';
      lb.querySelector('[data-cl-pname]').textContent=b.getAttribute('data-pname')||'';
      lb.querySelector('[data-cl-pprice]').textContent=b.getAttribute('data-pprice')||'';
    } else {prod.hidden=true}
    lb.hidden=false;document.body.style.overflow='hidden'};
  document.addEventListener('click',function(ev){
    var b=ev.target.closest?ev.target.closest('[data-cl-open]'):null;
    if(b){ev.preventDefault();open(b);return}
    if(ev.target.closest&&ev.target.closest('[data-cl-close]')){close();return}
    if(ev.target===lb)close();
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!lb.hidden)close()});
})();

/* HEROSLIDE */
(function(){var b=document.querySelector("[data-h2-box]");if(!b)return;var sl=b.querySelectorAll("[data-h2-slide]");if(sl.length<2){var d0=b.querySelector("[data-h2-dots]");if(d0)d0.remove();return}var dots=b.querySelector("[data-h2-dots]");var i=0,t=null,ms=(parseInt(b.getAttribute("data-ms"),10)||4)*1000;var btns=[];for(var k=0;k<sl.length;k++){(function(n){var d=document.createElement("button");d.type="button";d.className="h2__dot"+(n===0?" on":"");d.setAttribute("aria-label","Item "+(n+1));d.addEventListener("click",function(e){e.preventDefault();go(n);stop();start()});dots.appendChild(d);btns.push(d)})(k)}function go(n){sl[i].classList.remove("on");btns[i].classList.remove("on");i=n;sl[i].classList.add("on");btns[i].classList.add("on")}function nxt(){go((i+1)%sl.length)}function start(){t=setInterval(nxt,ms)}function stop(){if(t){clearInterval(t);t=null}}b.addEventListener("mouseenter",stop);b.addEventListener("mouseleave",start);document.addEventListener("visibilitychange",function(){if(document.hidden){stop()}else{for(var q=0;q<sl.length;q++){sl[q].style.transition="none"}go(i);setTimeout(function(){for(var q=0;q<sl.length;q++){sl[q].style.transition=""}},60);start()}});start()})();

/* LIVEAPI */
(function(){var pill=document.querySelector("[data-live-pill]");var stage=document.querySelector("[data-live-stage]");var api=pill?pill.getAttribute("data-live-api"):"";if(!api)return;function apply(d){if(!d||!d.live)return;if(pill)pill.hidden=false;if(stage&&d.url&&!stage.querySelector("iframe")){var src="https://www.facebook.com/plugins/video.php?href="+encodeURIComponent(d.url)+"&show_text=false&autoplay=true&width=405";stage.innerHTML='<div class="lv__ratio"><iframe src="'+src+'" title="LIVE" loading="lazy" allowfullscreen allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" scrolling="no" frameborder="0"></iframe></div>';var s=stage.closest(".lv");if(s){s.classList.add("lv--on");var bg=s.querySelector(".lv__badge");if(bg)bg.innerHTML="<i></i>LIVE now"}}}var c=null;try{c=JSON.parse(sessionStorage.getItem("wpLive")||"null")}catch(e){}if(c&&c.t&&(Date.now()-c.t)<60000){apply(c.d);return}fetch(api,{cache:"no-store"}).then(function(r){return r.json()}).then(function(d){try{sessionStorage.setItem("wpLive",JSON.stringify({t:Date.now(),d:d}))}catch(e){}apply(d)}).catch(function(){})})();

/* LVARROW */
(function(){var g=document.querySelector('.lv__pr');if(!g||g.parentElement.classList.contains('lv__prw'))return;var w=document.createElement('div');w.className='lv__prw';g.parentElement.insertBefore(w,g);w.appendChild(g);var mk=function(d,p){var b=document.createElement('button');b.type='button';b.className='lva lva--'+d;b.setAttribute('aria-label',d==='p'?'Previous':'Next');b.innerHTML='<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="'+p+'"/></svg>';w.appendChild(b);return b};var pv=mk('p','M15 5l-7 7 7 7'),nx=mk('n','M9 5l7 7-7 7');var st=function(){pv.disabled=g.scrollLeft<8;nx.disabled=g.scrollLeft+g.clientWidth>=g.scrollWidth-8};var go=function(s){var c=g.querySelector('.lv__p');var d=c?c.getBoundingClientRect().width+12:170;g.scrollBy({left:s*d*2,behavior:'smooth'})};pv.addEventListener('click',function(){go(-1)});nx.addEventListener('click',function(){go(1)});g.addEventListener('scroll',st,{passive:true});window.addEventListener('resize',st);st()})();

/* TOOLRAIL */
(function(){
var T=[['/pages/protein-finder','Which protein is right for you?','Answer 4 quick questions to find your formula'],['/pages/protein-calculator','Calculate your daily protein','Based on body weight and activity level'],['/pages/calorie-calculator','Calculate your daily calories','BMR and TDEE for your goal'],['/pages/fiber-calculator','Calculate your daily fibre','See your daily fibre target'],['/pages/protein-compare','Compare protein sources and cost per gram','Same protein — how much of each food?'],['/pages/water-calculator','Calculate your daily water','Based on body weight and exercise'],['/pages/body-check','Check the healthy weight range for your height','Enter weight, height and age']];
var cur=location.pathname.replace(/\/$/,'');var isTool=false;for(var k=0;k<T.length;k++){if(T[k][0]===cur)isTool=true}
var host=document.querySelector('.tl-more');
if(!host){if(!isTool)return;var anchor=document.querySelector('[id^="shopify-section-template"] .wp-wrap')||document.querySelector('[id^="shopify-section-template"]');if(!anchor)return;host=document.createElement('div');host.className='tl-more tl-more--auto';anchor.appendChild(host)}
var h='<b>Other tools</b><div class="tlr-w"><div class="tlr" data-tlr>';for(var i=0;i<T.length;i++){if(T[i][0]===cur)continue;h+='<a class="tlr-c" href="'+T[i][0]+'"><b>'+T[i][1]+'</b><em>'+T[i][2]+'</em><span class="tlr-go">Open tool &rarr;</span></a>'}h+='</div></div>';host.innerHTML=h;
var g=host.querySelector('[data-tlr]');var w=host.querySelector('.tlr-w');
var mk=function(d,p){var b=document.createElement('button');b.type='button';b.className='tlra tlra--'+d;b.setAttribute('aria-label',d==='p'?'Previous':'Next');b.innerHTML='<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="'+p+'"/></svg>';w.appendChild(b);return b};
var pv=mk('p','M15 5l-7 7 7 7'),nx=mk('n','M9 5l7 7-7 7');var st=function(){pv.disabled=g.scrollLeft<8;nx.disabled=g.scrollLeft+g.clientWidth>=g.scrollWidth-8};var go=function(s){var c=g.querySelector('.tlr-c');var d=c?c.getBoundingClientRect().width+14:250;g.scrollBy({left:s*d*2,behavior:'smooth'})};pv.addEventListener('click',function(){go(-1)});nx.addEventListener('click',function(){go(1)});g.addEventListener('scroll',st,{passive:true});window.addEventListener('resize',st);st()})();

/* FACTRAIL */
(function(){var g=document.querySelector('[data-wpf]');if(!g)return;var w=g.parentElement;if(!w.classList.contains('wpf-w'))return;
var mk=function(d,p){var b=document.createElement('button');b.type='button';b.className='wpfa wpfa--'+d;b.setAttribute('aria-label',d==='p'?'Previous':'Next');b.innerHTML='<svg viewBox="0 0 24 24" width="19" height="19" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="'+p+'"/></svg>';w.appendChild(b);return b};
var pv=mk('p','M15 5l-7 7 7 7'),nx=mk('n','M9 5l7 7-7 7');var st=function(){pv.disabled=g.scrollLeft<8;nx.disabled=g.scrollLeft+g.clientWidth>=g.scrollWidth-8};var go=function(s){var c=g.querySelector('.wp-fact');var d=c?c.getBoundingClientRect().width+16:330;g.scrollBy({left:s*d*2,behavior:'smooth'})};pv.addEventListener('click',function(){go(-1)});nx.addEventListener('click',function(){go(1)});g.addEventListener('scroll',st,{passive:true});window.addEventListener('resize',st);st()})();

/* TOOLBACK */
(function(){var P=['/pages/protein-finder','/pages/protein-calculator','/pages/calorie-calculator','/pages/fiber-calculator','/pages/protein-compare','/pages/water-calculator','/pages/body-check'];var cur=location.pathname.replace(/\/$/,'');if(P.indexOf(cur)<0)return;
var AR='<svg class="tk-ar" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>';
var ks=document.querySelectorAll('[class*="-kick"]');var k=null;for(var i=0;i<ks.length;i++){if(ks[i].offsetParent!==null&&ks[i].tagName!=='A'){k=ks[i];break}}
if(k){var a=document.createElement('a');a.href='/pages/tools';a.className=k.className+' tk-back';a.setAttribute('title','Back to all tools');a.innerHTML=AR+k.innerHTML;k.parentElement.replaceChild(a,k);return}
var h1=document.querySelector('h1');if(!h1)return;var b=document.createElement('a');b.href='/pages/tools';b.className='tk-pill';b.innerHTML=AR+'<span>All tools</span>';h1.parentElement.insertBefore(b,h1)})();

/* CRUMBS */
(function(){var p=location.pathname.replace(/\/+$/,'');if(p===''||p==='/')return;if(document.querySelector('.wp-crumbs'))return;
var h1=document.querySelector('h1');var host=h1?h1.parentElement:(document.querySelector('[id^="shopify-section-template"] .wp-wrap')||null);if(!host)return;
var label=h1?h1.textContent.replace(/\s+/g,' ').trim():(document.title.split('–')[0].trim());if(!label)label='This page';if(label.length>58)label=label.slice(0,58)+'…';
var nav=document.createElement('nav');nav.className='wp-crumbs wp-crumbs--auto';nav.innerHTML='<a href="/">Home</a><span>›</span><span>'+label.replace(/</g,'&lt;')+'</span>';
var ref=host.querySelector('.tk-pill')||h1||host.firstElementChild;if(ref)host.insertBefore(nav,ref);else host.insertBefore(nav,host.firstChild)})();

/* SHORTS */
(function(){
  var g = document.querySelector('[data-shorts]');
  if (!g) return;
  var api = (g.getAttribute('data-api') || '').trim();
  /* data-api is optional. With no endpoint we render straight from the curated clip map. */
  var limit = Number(g.getAttribute('data-limit') || 10) || 10;
  var mode = g.getAttribute('data-mode') || 'grid';
  var auto = g.getAttribute('data-auto') === '1';
  var moreU = g.getAttribute('data-more') || '';
  var moreT = g.getAttribute('data-moretxt') || 'See all clips';

  function vid(k){ var m = String(k||'').match(/[A-Za-z0-9_-]{11}/); return m ? m[0] : ''; }
  var RAW = {}, MAP = {};
  try { var s = document.querySelector('[data-shorts-map]'); if (s) RAW = JSON.parse(s.textContent || '{}'); } catch(e){}
  for (var k in RAW) { if (k === '_') continue; var id = vid(k); if (id) MAP[id] = RAW[k]; }

  function esc(x){ return String(x==null?'':x).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function mmss(n){ n = Number(n)||0; var m = Math.floor(n/60), s2 = n%60; return m + ':' + (s2<10?'0':'') + s2; }

  var PLAY = '<svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>';

  for (var i=0;i<(mode==='rail'?5:8);i++){ var d=document.createElement('div'); d.className='sh-sk'; g.appendChild(d); }

  function card(v){
    var meta = MAP[v.id] || {};
    var title = meta.t || v.title || '';
    var a = document.createElement('a');
    a.className = 'sh-c';
    a.href = v.url || ('https://www.youtube.com/shorts/' + v.id);
    a.setAttribute('data-vid', v.id);
    var tagged = meta.p && meta.p.length ? '<span class="sh-c__tag">Featured products</span>' : '';
    a.innerHTML =
      '<span class="sh-c__m">' +
        '<img class="sh-c__bg" src="https://i.ytimg.com/vi/' + v.id + '/hqdefault.jpg" alt="" loading="lazy" aria-hidden="true">' +
        '<img class="sh-c__fg" src="https://i.ytimg.com/vi/' + v.id + '/oardefault.jpg" alt="' + esc(title) + '" loading="lazy" ' +
          'onerror="this.onerror=null;this.src=\'https://i.ytimg.com/vi/' + v.id + '/hqdefault.jpg\'">' +
        tagged +
        '<span class="sh-c__pl">' + PLAY + '</span>' +
        (v.seconds ? '<span class="sh-c__d">' + mmss(v.seconds) + '</span>' : '') +
      '</span>' +
      '<span class="sh-c__t">' + esc(title) + '</span>';
    var fg = a.querySelector('.sh-c__fg');
    var tries = ['hqdefault.jpg','mqdefault.jpg'], ti = 0;
    var swap = function(){ fg.classList.add('sh-c__fg--cv'); if (ti < tries.length) { fg.src = 'https://i.ytimg.com/vi/' + v.id + '/' + tries[ti++]; } };
    fg.addEventListener('load', function(){ if (fg.naturalWidth && fg.naturalWidth <= 200) swap(); });
    fg.addEventListener('error', function(){ if (!fg.classList.contains('sh-c__fg--cv')) swap(); });
    if (fg.complete && fg.naturalWidth && fg.naturalWidth <= 200) swap();
    a.addEventListener('click', function(e){ e.preventDefault(); open(v, meta); });
    return a;
  }

  /* ---------- lightbox ---------- */
  var lb = null;
  function ensure(){
    if (lb) return lb;
    lb = document.createElement('div');
    lb.className = 'sh-lb';
    lb.hidden = true;
    lb.innerHTML = '<button class="sh-lb__x" type="button" aria-label="Close">&times;</button><div class="sh-lb__in"><div class="sh-lb__v"></div><div class="sh-lb__s"></div></div>';
    document.body.appendChild(lb);
    lb.addEventListener('click', function(e){ if (e.target === lb || e.target.closest('.sh-lb__x')) close(); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') close(); });
    return lb;
  }
  function close(){
    if (!lb) return;
    lb.querySelector('.sh-lb__v').innerHTML = '';
    lb.hidden = true;
    document.documentElement.style.overflow = '';
  }
  function open(v, meta){
    ensure();
    var src = 'https://www.youtube.com/embed/' + v.id + '?autoplay=1&playsinline=1&rel=0&modestbranding=1';
    lb.querySelector('.sh-lb__v').innerHTML =
      '<iframe src="' + src + '" title="' + esc(meta.t || v.title || '') + '" allow="autoplay; encrypted-media; picture-in-picture; web-share" allowfullscreen></iframe>';
    var ps = (meta.p || []);
    var h = '<h3>' + esc(meta.t || v.title || '') + '</h3>';
    if (meta.c) h += '<div class="sh-lb__k">' + esc(meta.c) + '</div>';
    if (ps.length) {
      h += '<div class="sh-lb__k">Products in this clip</div>';
      for (var i=0;i<ps.length;i++){
        var p = ps[i];
        h += '<a class="sh-p" href="' + esc(p.u) + '">' +
             (p.i ? '<img src="' + esc(p.i) + '" alt="" loading="lazy">' : '') +
             '<span><b>' + esc(p.t) + '</b><em>' + esc(p.pr) + '</em></span></a>';
      }
    } else {
      h += '<div class="sh-lb__k">Products in this clip</div><p class="sh-lb__none">This clip has no tagged products yet. Browse the full range in the store.</p>';
    }
    var lbc = (meta && meta.c) ? String(meta.c) : '';
    if (lbc) {
      h += '<button class="sh-lb__yt" type="button" data-cat="' + esc(lbc) + '">More clips in ' + esc(lbc) + ' &rarr;</button>';
    } else {
      h += '<a class="sh-lb__yt" href="/pages/videos">See all WISAMIN clips &rarr;</a>';
    }
    lb.querySelector('.sh-lb__s').innerHTML = h;
    lb.hidden = false;
    document.documentElement.style.overflow = 'hidden';
  }

  /* ---------- arrows ---------- */
  function arrows(){
    if (mode !== 'rail') return;
    var w = g.parentElement;
    if (!w || w.querySelector('.sha')) return;
    var mk = function(d, p){
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'sha sha--' + d;
      b.setAttribute('aria-label', d === 'p' ? 'Previous' : 'Next');
      b.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="' + p + '"/></svg>';
      w.appendChild(b); return b;
    };
    var pv = mk('p','M15 5l-7 7 7 7'), nx = mk('n','M9 5l7 7-7 7');
    var st = function(){ pv.disabled = g.scrollLeft < 8; nx.disabled = g.scrollLeft + g.clientWidth >= g.scrollWidth - 8; };
    var go = function(s){ var c = g.querySelector('.sh-c'); var d = c ? c.getBoundingClientRect().width + 16 : 224; g.scrollBy({ left: s*d*2, behavior:'smooth' }); };
    pv.addEventListener('click', function(){ go(-1); });
    nx.addEventListener('click', function(){ go(1); });
    g.addEventListener('scroll', st, { passive:true });
    window.addEventListener('resize', st);
    st();
  }

  /* ---------- inline autoplay (first visible clip) ---------- */
  function inlineAuto(){
    if (!auto || !('IntersectionObserver' in window)) return;
    var done = false;
    var io = new IntersectionObserver(function(en){
      en.forEach(function(x){
        if (!x.isIntersecting || done) return;
        done = true; io.disconnect();
        var a = x.target, id = a.getAttribute('data-vid');
        var box = a.querySelector('.sh-c__m');
        var f = document.createElement('iframe');
        f.className = 'sh-c__f';
        f.allow = 'autoplay; encrypted-media';
        f.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&mute=1&loop=1&playlist=' + id +
                '&controls=0&playsinline=1&rel=0&modestbranding=1&disablekb=1';
        box.appendChild(f);
      });
    }, { threshold: 0.3 });
    var first = g.querySelector('.sh-c');
    if (first) io.observe(first);
  }

  function paint(items){
    /* Nothing to show (no feed yet, feed down, or channel still empty):
       hide the whole section rather than leave a heading with an empty rail. */
    if (!items || !items.length) {
      var sec = document.getElementById('wp-shorts');
      if (!sec) return;
      var em = sec.querySelector('[data-shorts-empty]');
      if (em) {
        /* Standalone Videos page: show a short message instead of a blank page. */
        sec.style.display = '';
        em.hidden = false;
        var wrap = sec.querySelector('.sh-w'); if (wrap) wrap.style.display = 'none';
        var hl = sec.querySelector('.wp-h a'); if (hl) hl.style.display = 'none';
      } else {
        sec.style.display = 'none';
      }
      return;
    }
    var secOn = document.getElementById('wp-shorts');
    if (secOn) {
      secOn.style.display = '';
      var em2 = secOn.querySelector('[data-shorts-empty]');
      if (em2) em2.hidden = true;
      var wrap2 = secOn.querySelector('.sh-w'); if (wrap2) wrap2.style.display = '';
    }
    items.forEach(function(v){ var m = MAP[v.id]; v._f = m && m.f ? 1 : 0; v._r = m && m.r != null ? m.r : 999; });
    items.sort(function(a,b){
      if (a._f !== b._f) return b._f - a._f;
      if (a._f && a._r !== b._r) return a._r - b._r;
      return String(b.published).localeCompare(String(a.published));
    });
    items = items.slice(0, limit);
    g.innerHTML = '';
    items.forEach(function(v){ g.appendChild(card(v)); });
    if (moreU) {
      var a = document.createElement('a');
      a.className = 'sh-more'; a.href = moreU;
      a.innerHTML = '<svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg><span>' + esc(moreT) + '</span>';
      g.appendChild(a);
    }
    arrows(); inlineAuto();
  }

  function fromMap(){
    var out = [];
    for (var mk in MAP) {
      out.push({ id: mk, url: 'https://www.youtube.com/shorts/' + mk, title: MAP[mk].t || '', published: '', seconds: MAP[mk].s || 0 });
    }
    return out;
  }

  if (api) {
    fetch(api, { cache: 'no-store' })
      .then(function(r){ return r.json(); })
      .then(function(d){
        var items = (d && d.items) || [];
        if (!items.length) items = fromMap();
        paint(items);
      })
      .catch(function(){ paint(fromMap()); });
  } else {
    paint(fromMap());
  }
})();

/* RAILDOT */
(function(){var SEL='.wr__track,.sh-g--rail,.rw-g--rail,.wp-facts,.tlr,.lv__pr,.wp-kn--rail';
function upd(t,el){var sw=el.scrollWidth,cw=el.clientWidth;if(sw<=cw+8){t.style.display='none';return}t.style.display='';var W=t.clientWidth||72;var tw=Math.max(16,Math.round(W*cw/sw));var mx=W-tw;var d=sw-cw;var x=d>0?Math.round(mx*(el.scrollLeft/d)):0;var b=t.firstChild;b.style.width=tw+'px';b.style.transform='translateX('+x+'px)'}
function attach(el){if(el.__rd)return;el.__rd=1;var t=document.createElement('div');t.className='rdot';t.setAttribute('aria-hidden','true');t.appendChild(document.createElement('i'));if(!el.parentNode)return;el.parentNode.insertBefore(t,el.nextSibling);var raf=0;var go=function(){if(raf)return;raf=requestAnimationFrame(function(){raf=0;upd(t,el)})};el.addEventListener('scroll',go,{passive:true});window.addEventListener('resize',go);if(window.ResizeObserver){try{new ResizeObserver(go).observe(el)}catch(e){}}upd(t,el);setTimeout(function(){upd(t,el)},150);setTimeout(function(){upd(t,el)},900);setTimeout(function(){upd(t,el)},2500)}
function scan(){[].forEach.call(document.querySelectorAll(SEL),function(el){var cs=getComputedStyle(el);if(!/auto|scroll/.test(cs.overflowX))return;if(el.children.length<3)return;attach(el)})}
scan();document.addEventListener('DOMContentLoaded',scan);window.addEventListener('load',scan);setTimeout(scan,1200);setTimeout(scan,3000)})();

/* MBURGER */
(function(){function go(){var n=document.querySelector('.wp-nav__in'),r=document.querySelector('.wp-hd__row');if(!n||!r||document.querySelector('.wm-bg'))return;var b=document.createElement('button');b.className='wm-bg';b.type='button';b.setAttribute('aria-label','Menu');b.setAttribute('aria-expanded','false');b.innerHTML='<i></i><i></i><i></i>';r.insertBefore(b,r.firstChild);b.addEventListener('click',function(e){e.stopPropagation();var o=document.body.classList.toggle('wm-open');b.setAttribute('aria-expanded',o?'true':'false')});n.addEventListener('click',function(e){if(e.target.closest('a'))document.body.classList.remove('wm-open')});document.addEventListener('click',function(e){if(!document.body.classList.contains('wm-open'))return;if(e.target.closest('.wp-hd__main'))return;document.body.classList.remove('wm-open');b.setAttribute('aria-expanded','false')})}if(document.readyState!=='loading')go();else document.addEventListener('DOMContentLoaded',go);document.addEventListener('shopify:section:load',go);setTimeout(go,900)})();

/* WTRACK */
(function(){
var f=document.querySelector('[data-wtk-form]');if(!f)return;
var out=document.querySelector('[data-wtk-out]');
var api=(f.getAttribute('data-api')||'').replace(/\/+$/,'');
var E={'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'};
var esc=function(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return E[c]})};
var FS={FULFILLED:'Delivered',UNFULFILLED:'Awaiting fulfilment',PARTIALLY_FULFILLED:'Partially fulfilled',IN_PROGRESS:'In transit',ON_HOLD:'On hold',SCHEDULED:'Scheduled',RESTOCKED:'Restocked'};
var PS={PAID:'Paid',PENDING:'Pending payment',REFUNDED:'Refunded',PARTIALLY_REFUNDED:'Partially refunded',VOIDED:'Payment voided',AUTHORIZED:'Authorised'};
var msg=function(h){out.hidden=false;out.innerHTML=h};
var D=function(s){try{return new Date(s).toLocaleDateString('th-TH',{day:'numeric',month:'short',year:'numeric'})}catch(e){return ''}};
f.addEventListener('submit',async function(e){
e.preventDefault();
var o=f.order.value.trim(),em=f.email.value.trim();
if(!o||!em){msg('<div class="wtk__err">Please enter both your order number and email.</div>');return}
var btn=f.querySelector('button');var ot=btn.textContent;btn.disabled=true;btn.textContent='Searching...';
msg('<div class="wtk__load">Checking your order...</div>');
var j=null;
try{var r=await fetch(api+'/track',{method:'POST',headers:{'content-type':'application/json'},body:JSON.stringify({order:o,email:em})});j=await r.json()}catch(err){j={ok:false,code:'net'}}
btn.disabled=false;btn.textContent=ot;
if(!j||!j.ok){
var M={not_found:'No matching order found. Please check the order number and email.',bad_input:'Please check your order number and email.',not_configured:'Order tracking is being switched on. In the meantime, message our team.',upstream:'Temporary error. Please try again.',net:'Connection failed. Please try again.'};
msg('<div class="wtk__err">'+esc(M[(j&&j.code)||'net']||M.net)+'</div>');return}
var d=j.order;var h='<div class="wtk__card">';
h+='<div class="wtk__top"><b>'+esc(d.name)+'</b><span>Ordered '+esc(D(d.at))+'</span></div>';
h+='<div class="wtk__pills"><span class="wtk__pill wtk__pill--f">'+esc(FS[d.fulfillment]||d.fulfillment||'-')+'</span><span class="wtk__pill">'+esc(PS[d.payment]||d.payment||'-')+'</span>'+(d.cancelled?'<span class="wtk__pill wtk__pill--x">Cancelled</span>':'')+'</div>';
if(d.tracking&&d.tracking.length){h+='<div class="wtk__tk">';d.tracking.forEach(function(t){h+='<div class="wtk__tkr"><div><b>'+esc(t.company||'Parcel')+'</b><em>'+esc(t.number||'-')+'</em></div>'+(t.url?'<a class="wp-btn wp-btn--g" target="_blank" rel="noopener" href="'+esc(t.url)+'">Track my order</a>':'')+'</div>'});h+='</div>'}
else{h+='<p class="wtk__wait">No tracking number yet — we are preparing your parcel. It will appear here as soon as it updates.</p>'}
if(d.items&&d.items.length){h+='<ul class="wtk__it">';d.items.forEach(function(i){h+='<li><span>'+esc(i.t)+'</span><em>x'+esc(i.q)+'</em></li>'});h+='</ul>'}
h+='</div>';msg(h);
});})();

/* WCH */
(function(){
function init(){var w=document.querySelector("[data-wp-ch]");if(!w||w.__i)return;w.__i=1;
var b=w.querySelector(".wp-ch__fab"),p=w.querySelector(".wp-ch__pop");if(!b||!p)return;
function set(o){if(o){p.hidden=false}else{p.hidden=true}w.classList[o?"add":"remove"]("is-open");b.setAttribute("aria-expanded",o?"true":"false")}
b.addEventListener("click",function(e){e.preventDefault();e.stopPropagation();set(!w.classList.contains("is-open"))});
document.addEventListener("click",function(e){if(!w.contains(e.target))set(false)});
document.addEventListener("keydown",function(e){if(e.key==="Escape"||e.keyCode===27)set(false)});
p.addEventListener("click",function(e){var a=e.target.closest?e.target.closest("a"):null;if(a)setTimeout(function(){set(false)},80)});}
init();document.addEventListener("DOMContentLoaded",init);window.addEventListener("load",init);
document.addEventListener("shopify:section:load",function(){var w=document.querySelector("[data-wp-ch]");if(w)w.__i=0;init()});
setTimeout(init,900);setTimeout(init,2500);})();

/* POLDOC */
(function(){
if(location.pathname.indexOf("/policies/")!==0)return;
var PL=[["/policies/shipping-policy","Shipping policy"],["/policies/refund-policy","Refund policy"],["/policies/terms-of-service","Terms of service"],["/policies/privacy-policy","Privacy policy"],["/policies/contact-information","Contact information"]];
function nz(s){return (s||"").replace(/[\s\u00a0\u200b]/g,"")}
function cl(s){return (s||"").replace(/\s+/g," ").replace(/^[\*\u2022\u25cf\u25aa\-\u2013]\s*/,"").trim()}
function mk(t,c){var e=document.createElement(t);if(c)e.className=c;return e}
function restruct(rte){
 if(rte.querySelector("h2,h3"))return false;
 var blocks=[];[].forEach.call(rte.children,function(b){blocks.push(b)});if(!blocks.length)blocks=[rte];
 var lines=[];
 blocks.forEach(function(b){var cur=[];[].forEach.call(b.childNodes,function(n){if(n.nodeName==="BR"){lines.push(cur);cur=[]}else{cur.push(n.cloneNode(true))}});lines.push(cur)});
 var out=mk("div","pol__rw"),sec=null;
 function push(el){if(!sec){sec=mk("section","pol__s");out.appendChild(sec)}sec.appendChild(el)}
 var ul=null;
 lines.forEach(function(ns){
  var tmp=mk("div");ns.forEach(function(n){tmp.appendChild(n)});
  var t=cl(tmp.textContent);if(!t){ul=null;return}
  var st=tmp.querySelector("strong,b");var sv=st?cl(st.textContent):"";
  var isH=!!st&&sv.length>0&&t.length<=140&&nz(sv).length>=nz(t).length*0.55;
  var raw=tmp.textContent.replace(/\s+/g," ").trim();
  var isLi=/^[\*\u2022\u25cf\u25aa]/.test(raw)&&!isH;
  if(isH){ul=null;sec=mk("section","pol__s");out.appendChild(sec);var h=mk("h2");var m=sv.match(/^(\d+)[.)]\s*/);var sd=sv.replace(/[:\uff1a\s]+$/,"");
   if(m){var b2=mk("span","pol__n");b2.textContent=m[1];h.appendChild(b2);h.appendChild(document.createTextNode(sd.slice(m[0].length)))}else{h.appendChild(document.createTextNode(sd))}sec.appendChild(h);
   var rest=cl(t.slice(sv.length)).replace(/^[:\uff1a\-\u2013\u2014\s]+/,"");if(rest.length>1){var p0=mk("p");p0.textContent=rest;sec.appendChild(p0)}return}
  if(isLi){if(!ul){ul=mk("ul","pol__ul");push(ul)}var li=mk("li");li.innerHTML=tmp.innerHTML.replace(/^\s*[\*\u2022\u25cf\u25aa]\s*/,"");ul.appendChild(li);return}
  ul=null;var p=mk("p");p.innerHTML=tmp.innerHTML;push(p);
 });
 return out;
}
function side(c,rte){
 var g=mk("div","pol__grid");var a=mk("aside","pol__side");
 var nv=mk("div","pol__nav");var nt=mk("b","pol__nt");nt.textContent="All policies";nv.appendChild(nt);
 PL.forEach(function(p){var l=mk("a","pol__nl"+(location.pathname===p[0]?" is-on":""));l.href=p[0];var s=mk("span");s.textContent=p[1];l.appendChild(s);l.appendChild(mk("i"));nv.appendChild(l)});
 a.appendChild(nv);
 var hs=rte.querySelectorAll("h2");
 if(hs.length>2){var tc=mk("div","pol__toc");var tt=mk("b","pol__nt");tt.textContent="On this page";tc.appendChild(tt);var lw=mk("div","pol__tl");
  [].forEach.call(hs,function(h,i){if(!h.id)h.id="pol-"+(i+1);var l=mk("a");l.href="#"+h.id;var n=h.querySelector(".pol__n");var tx=cl(h.textContent);if(n){var nn=cl(n.textContent);tx=nn+". "+cl(tx.slice(nn.length))}l.textContent=tx;lw.appendChild(l)});
  tc.appendChild(lw);a.appendChild(tc)}
 var hp=mk("a","pol__help");hp.href="/pages/contact";hp.innerHTML='<span class="pol__hi"></span><span class="pol__ht"><b>Questions??</b><i>Message us on any channel</i></span>';a.appendChild(hp);
 var bd=c.querySelector(".shopify-policy__body");
 bd.parentNode.insertBefore(g,bd);g.appendChild(a);g.appendChild(bd);
 var ft=mk("div","pol__foot");ft.innerHTML='<span class="pol__fi"></span><p>This is the version currently in force. Any revision will be published on this page.<br><b>MAX GLOBAL MARKETING CO., LTD.</b> — Distributor of supplements under the brand WISAMIN (WISAMIN)</p>';
 bd.appendChild(ft);
}
function run(){
 var c=document.querySelector(".shopify-policy__container");if(!c||c.__p)return;c.__p=1;
 document.body.classList.add("wp-policy");
 var rte=c.querySelector(".shopify-policy__body .rte");if(!rte)return;
 var otx=nz(rte.innerText);
 try{var nw=restruct(rte);if(nw){var ck=mk("div");ck.appendChild(nw.cloneNode(true));document.body.appendChild(ck);var ntx=nz(ck.innerText);document.body.removeChild(ck);
  if(ntx.length>=otx.length*0.98){rte.innerHTML="";rte.appendChild(nw)}}}catch(e){}
 try{var h1=c.querySelector("h1");var s1=rte.querySelector(".pol__s");
  if(h1&&s1){var hh=s1.querySelector("h2");if(hh&&nz(hh.textContent).indexOf(nz(h1.textContent))>=0){s1.classList.add("pol__s--lead");hh.parentNode.removeChild(hh)}}}catch(e){}
 try{side(c,rte)}catch(e){}
 var f=c.querySelector(".shopify-policy__title");if(f&&!f.querySelector(".pol__deco")){var d=mk("span","pol__deco");f.appendChild(d)}
}
if(document.readyState!=="loading")run();else document.addEventListener("DOMContentLoaded",run);
window.addEventListener("load",run);setTimeout(run,700);setTimeout(run,2000);
})();

;(function(){document.addEventListener("click",function(e){var b=e.target.closest&&e.target.closest("[data-wpt-copy]");if(!b)return;e.preventDefault();var c=b.getAttribute("data-wpt-copy")||"";try{navigator.clipboard.writeText(c)}catch(x){}var t=b.textContent;b.textContent="Copied";setTimeout(function(){b.textContent=t},1600)})})();

/* DEALGUARD */
(function(){
  function fix(){
    var now = Math.floor(Date.now()/1000);
    Array.prototype.forEach.call(document.querySelectorAll('[data-dl-s]'), function(el){
      var s = parseInt(el.getAttribute('data-dl-s'),10);
      var e = parseInt(el.getAttribute('data-dl-e'),10);
      if(now >= s && now <= e){ return; }
      var base = el.getAttribute('data-dl-base');
      var ref = el.getAttribute('data-dl-ref') || '';
      var b = el.querySelector('b');
      if(b && base){ b.textContent = base; }
      var st = el.querySelector('s');
      if(st){ if(ref){ st.textContent = ref; } else { st.parentNode.removeChild(st); } }
      var tg = el.querySelector('.wp-pdp__dl');
      if(tg){ tg.parentNode.removeChild(tg); }
      el.removeAttribute('data-dl-s');
      var card = el.closest ? el.closest('article') : null;
      if(card){ var t = card.querySelector('.wp-tag--dl'); if(t){ t.parentNode.removeChild(t); } }
    });
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', fix); } else { fix(); }
})();

/* WSEL */
(function(){
  var MQ = window.matchMedia ? window.matchMedia('(max-width:900px)') : null;
  var cur = null;
  function close(){ if(cur){ cur.w.classList.remove('is-open'); cur.l.hidden = true; cur = null; } }
  document.addEventListener('click', function(e){ if(cur && !cur.w.contains(e.target) && !cur.l.contains(e.target)) close(); }, true);
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') close(); });
  window.addEventListener('scroll', function(){ if(cur) close(); }, true);
  window.addEventListener('resize', function(){ if(cur) close(); });
  function place(b, l){
    var r = b.getBoundingClientRect();
    var vh = window.innerHeight;
    var below = vh - r.bottom - 12;
    var above = r.top - 12;
    l.style.left = Math.max(8, r.left) + 'px';
    l.style.width = r.width + 'px';
    if(below >= 200 || below >= above){
      l.style.top = (r.bottom + 6) + 'px';
      l.style.bottom = 'auto';
      l.style.maxHeight = Math.max(150, below) + 'px';
    } else {
      l.style.bottom = (vh - r.top + 6) + 'px';
      l.style.top = 'auto';
      l.style.maxHeight = Math.max(150, above) + 'px';
    }
  }
  function build(sel){
    if(sel.getAttribute('data-wsel')) return;
    sel.setAttribute('data-wsel','1');
    var w = document.createElement('div');
    w.className = 'wsel';
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'wsel__b';
    b.innerHTML = '<span class="wsel__t"></span><svg viewBox="0 0 24 24" class="wsel__c" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
    var l = document.createElement('div');
    l.className = 'wsel__l is-fixed';
    l.hidden = true;
    sel.parentNode.insertBefore(w, sel);
    w.appendChild(b); w.appendChild(sel);
    document.body.appendChild(l);
    function paint(){
      var o = sel.options[sel.selectedIndex];
      b.querySelector('.wsel__t').textContent = o ? o.textContent.trim() : '';
      l.innerHTML = '';
      for(var i=0;i<sel.options.length;i++){
        (function(op, idx){
          var it = document.createElement('button');
          it.type = 'button';
          it.className = 'wsel__i' + (idx === sel.selectedIndex ? ' is-on' : '');
          it.textContent = op.textContent.trim();
          if(op.disabled) it.disabled = true;
          it.addEventListener('click', function(ev){
            ev.stopPropagation();
            sel.selectedIndex = idx;
            var e2; try{ e2 = new Event('change',{bubbles:true}); }catch(x){ e2 = document.createEvent('Event'); e2.initEvent('change', true, true); }
            sel.dispatchEvent(e2);
            paint(); close();
          });
          l.appendChild(it);
        })(sel.options[i], i);
      }
    }
    b.addEventListener('click', function(e){
      e.stopPropagation();
      if(cur && cur.w === w){ close(); return; }
      close();
      cur = { w: w, l: l };
      w.classList.add('is-open');
      l.hidden = false;
      place(b, l);
      var on = l.querySelector('.wsel__i.is-on');
      if(on) l.scrollTop = Math.max(0, on.offsetTop - 40);
    });
    sel.addEventListener('change', paint);
    paint();
  }
  function scan(){
    if(!MQ || !MQ.matches) return;
    var ss = document.querySelectorAll('select.wp-var, #wpVariant, .wp select');
    for(var i=0;i<ss.length;i++){
      var s0 = ss[i];
      if(s0.name === 'country_code' || s0.name === 'currency_code' || s0.multiple) continue;
      if(s0.closest && s0.closest('localization-form, [data-disclosure], .shopify-localization-form')) continue;
      try{ build(s0); }catch(e){}
    }
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', scan); } else { scan(); }
  if(MQ && MQ.addEventListener){ MQ.addEventListener('change', scan); }
  setTimeout(scan, 1500);
  document.addEventListener('shopify:section:load', scan);
})();

/* SHCAT */
(function(){
  function build(){
    var g = document.querySelector('[data-shorts][data-mode="grid"]');
    if(!g || g.getAttribute('data-catui')) return true;
    var cards = g.querySelectorAll('.sh-c');
    if(!cards.length) return false;
    g.setAttribute('data-catui','1');
    var root = document.getElementById('wp-shorts');
    if(root) root.classList.add('is-lib');
    var RAW = {};
    try{ var sm = document.querySelector('[data-shorts-map]'); if(sm) RAW = JSON.parse(sm.textContent || '{}'); }catch(e){}
    var MAP = {};
    for(var k in RAW){ if(k === '_') continue; var mm = String(k).match(/[A-Za-z0-9_-]{11}/); if(mm) MAP[mm[0]] = RAW[k]; }
    var cnt = {}, order = [];
    for(var i=0;i<cards.length;i++){
      var id = cards[i].getAttribute('data-vid');
      var c = (MAP[id] && MAP[id].c) ? String(MAP[id].c).trim() : '';
      cards[i].setAttribute('data-cat', c);
      if(c){ if(!cnt[c]){ cnt[c] = 0; order.push(c); } cnt[c]++; }
    }
    order.sort(function(a,b){ return cnt[b] - cnt[a]; });
    var head = document.createElement('div');
    head.className = 'sh-lib';
    var meta = document.createElement('div');
    meta.className = 'sh-lib__n';
    meta.textContent = 'Browse clips by category';
    head.appendChild(meta);
    var bar = document.createElement('div');
    bar.className = 'sh-cat';
    function apply(val){
      var n = 0;
      for(var j=0;j<cards.length;j++){
        var cc = cards[j].getAttribute('data-cat') || '';
        var on = (val === '' || cc === val);
        if(on){ cards[j].classList.remove('sh-c--off'); n++; }
        else { cards[j].classList.add('sh-c--off'); }
      }
      meta.textContent = 'Browse clips by category';
    }
    function chip(label, val, n){
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'sh-cat__b' + (val === '' ? ' is-on' : '');
      b.setAttribute('data-v', val);
      b.appendChild(document.createTextNode(label));
      var em = document.createElement('i');
      em.textContent = n;
      b.appendChild(em);
      b.addEventListener('click', function(){
        var all = bar.querySelectorAll('.sh-cat__b');
        for(var j=0;j<all.length;j++) all[j].classList.remove('is-on');
        b.classList.add('is-on');
        apply(val);
      });
      return b;
    }
    bar.appendChild(chip('All', '', cards.length));
    var SHOW = 7;
    for(var i2=0;i2<order.length;i2++){
      var ch = chip(order[i2], order[i2], cnt[order[i2]]);
      if(i2 >= SHOW) ch.classList.add('is-hid');
      bar.appendChild(ch);
    }
    if(order.length > SHOW){
      var mb = document.createElement('button');
      mb.type = 'button';
      mb.className = 'sh-cat__m';
      mb.textContent = '' + (order.length - SHOW) + ' categories';
      mb.addEventListener('click', function(){
        var op = bar.classList.toggle('is-open');
        mb.textContent = op ? 'Collapse' : ('' + (order.length - SHOW) + ' categories');
      });
      bar.appendChild(mb);
    }
    head.appendChild(bar);
    g.parentNode.insertBefore(head, g);
    return true;
  }
  var n = 0;
  var t = setInterval(function(){ if(build() || ++n > 40) clearInterval(t); }, 300);
})();

/* SHHERO */
(function(){
  function hero(){
    var root = document.getElementById('wp-shorts');
    if(!root || !root.classList.contains('is-lib')) return false;
    if(root.getAttribute('data-hero')) return true;
    var wrap = root.querySelector('.wp-wrap');
    var h = root.querySelector('.wp-h');
    if(!wrap || !h) return true;
    root.setAttribute('data-hero','1');
    var box = document.createElement('div');
    box.className = 'sh-hero';
    var inner = document.createElement('div');
    inner.className = 'sh-hero__in';
    var sub = root.querySelector('.sh-sub');
    wrap.insertBefore(box, h);
    box.appendChild(inner);
    inner.appendChild(h);
    if(sub) inner.appendChild(sub);
    var tag = document.createElement('span');
    tag.className = 'sh-hero__tag';
    tag.textContent = 'WISAMIN Studio';
    inner.insertBefore(tag, h);
    return true;
  }
  var n = 0;
  var t = setInterval(function(){ if(hero() || ++n > 40) clearInterval(t); }, 300);
})();

/* LBCTA */
(function(){
  function q(cat){ return document.querySelector('.sh-cat__b[data-v="' + String(cat).replace(/"/g,'') + '"]'); }
  function go(chip){
    var lb = document.querySelector('.sh-lb');
    if (lb && !lb.hidden) { var f = lb.querySelector('.sh-lb__v'); if (f) f.innerHTML = ''; lb.hidden = true; document.documentElement.style.overflow = ''; }
    chip.click();
    var g = document.querySelector('[data-shorts][data-mode="grid"]');
    if (g) { try { window.scrollTo({ top: g.getBoundingClientRect().top + window.pageYOffset - 80, behavior: 'smooth' }); } catch(e) {} }
  }
  document.addEventListener('click', function(e){
    var b = e.target && e.target.closest ? e.target.closest('.sh-lb__yt[data-cat]') : null;
    if (!b) return;
    e.preventDefault();
    var cat = b.getAttribute('data-cat') || '';
    var chip = q(cat);
    if (chip) { go(chip); } else { location.href = '/pages/videos#c=' + encodeURIComponent(cat); }
  }, true);
  function fromHash(){
    var m = /[#&]c=([^&]+)/.exec(location.hash || '');
    if (!m) return;
    var val = decodeURIComponent(m[1]);
    var n = 0, iv = setInterval(function(){
      var chip = q(val);
      if (chip) { clearInterval(iv); go(chip); }
      if (++n > 40) clearInterval(iv);
    }, 150);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', fromHash); } else { fromHash(); }
})();
